import { ethers } from 'ethers';
import { AuthorizationType } from './types';
export var AuthorizationError;
(function (AuthorizationError) {
    AuthorizationError["REVOKE_FAILED"] = "revoke-failed-error";
    AuthorizationError["GRANT_FAILED"] = "grant-failed-error";
    AuthorizationError["INSUFFICIENT_ALLOWANCE"] = "insufficient-allowance";
    AuthorizationError["FETCH_AUTHORIZATIONS_FAILURE"] = "fetch-authorizations-failure";
})(AuthorizationError || (AuthorizationError = {}));
export function getTokenAmountToApprove() {
    return ethers.BigNumber.from(2)
        .pow(256)
        .sub(1);
}
export function hasAuthorization(authorizations, authorizationToFind) {
    return authorizations.some(authorization => areEqual(authorization, authorizationToFind));
}
export function hasAuthorizationAndEnoughAllowance(authorizations, authorizationToFind, allowance) {
    const foundAuth = authorizations.find(authorization => areEqual(authorization, authorizationToFind));
    if (!foundAuth) {
        return false;
    }
    // It should only care in the case of allowance authorizations.
    // The rest don't have allowance so they can be ignored.
    if (authorizationToFind.type !== AuthorizationType.ALLOWANCE) {
        return true;
    }
    const { allowance: foundAuthAllowance } = foundAuth;
    if (!foundAuthAllowance) {
        return false;
    }
    const a = ethers.utils.parseEther(allowance);
    const b = ethers.utils.parseEther(foundAuthAllowance);
    return a.lte(b);
}
export function areEqual(left, right) {
    return (left.type === right.type &&
        left.authorizedAddress.toLowerCase() ===
            right.authorizedAddress.toLowerCase() &&
        left.contractAddress.toLowerCase() ===
            right.contractAddress.toLowerCase() &&
        left.chainId === right.chainId &&
        left.address.toLowerCase() === right.address.toLowerCase());
}
export function isValidType(type) {
    return Object.values(AuthorizationType).includes(type);
}
export function getERC20ContractInstance(contractAddress, provider) {
    return new ethers.Contract(contractAddress, [
        'function allowance(address owner, address spender) view returns (uint256)'
    ], provider);
}
export function getERC721ContractInstance(contractAddress, provider) {
    return new ethers.Contract(contractAddress, [
        'function isApprovedForAll(address owner, address operator) view returns (bool)'
    ], provider);
}
//# sourceMappingURL=utils.js.map